import React from 'react'
import { Accordion } from 'react-bootstrap'
import Coloritem from '../Coloritem';
import Colorcell from '../Colorcell';
import Colorsmbg from '../Colorsmbg';
import Colorstandout from '../Colorstandout';
import langList from '../../utils/languagelist.json';
import { useSelector } from 'react-redux';

export default function Colorbar() {
  const {lg}=useSelector((state)=>state.language);

  return (
    <Accordion flush>
      <Accordion.Item eventKey="30">
        <Accordion.Header>{langList.colorbar1[lg]}</Accordion.Header>
        <Accordion.Body>
          <Coloritem nu={'bg'}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="31">
        <Accordion.Header>{langList.colorbar2[lg]}</Accordion.Header>
        <Accordion.Body>
          <Coloritem nu={'tb'}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="32">
        <Accordion.Header>{langList.colorbar3[lg]}</Accordion.Header>
        <Accordion.Body>
          <Coloritem nu={'bm'}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="33">
        <Accordion.Header>{langList.colorbar4[lg]}</Accordion.Header>
        <Accordion.Body>
          <Coloritem nu={'bnu'}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="34">
        <Accordion.Header>{langList.colorbar5[lg]}</Accordion.Header>
        <Accordion.Body>
          <Coloritem nu={'hp'}/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="35">
        <Accordion.Header>{langList.colorbar6[lg]}</Accordion.Header>
        <Accordion.Body>
          <Colorcell/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="36">
        <Accordion.Header>{langList.colorbar7[lg]}</Accordion.Header>
        <Accordion.Body>
          <Colorsmbg/>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="37">
        <Accordion.Header>{langList.colorbar8[lg]}</Accordion.Header>
        <Accordion.Body>
          <Colorstandout/>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
};

